/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Fairuse_Section3title2Inputs */

const id_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Kepatuhan terhadap Penggunaan Wajar`)
};

const ms_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Pematuhan Penggunaan Adil`)
};

const da_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Overholdelse af Fair Use`)
};

const de_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Einhaltung der fairen Nutzung`)
};

const en_us2_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Compliance with Fair Use`)
};

const es_es2_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Cumplimiento del uso justo`)
};

const es_mx2_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Cumplimiento del uso justo`)
};

const fil_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Pagsunod sa Patas na Paggamit`)
};

const fr_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Conformité à l'utilisation équitable`)
};

const it_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Conformità al Fair Use`)
};

const hu_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Megfelelés a Fair Use-nak`)
};

const nl_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Naleving van Fair Use`)
};

const no_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Overholdelse av rimelig bruk`)
};

const pl_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Zgodność z dozwolonym użytkiem`)
};

const pt_br2_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Conformidade com o uso justo`)
};

const pt_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Conformidade com o Uso Justo`)
};

const ro_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Conformitatea cu utilizarea corectă`)
};

const fi_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Kohtuullisen käytön noudattaminen`)
};

const sv_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Efterlevnad av skälig användning`)
};

const vi_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Tuân thủ sử dụng hợp lý`)
};

const tr_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Adil Kullanıma Uygunluk`)
};

const cs_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Soulad se spravedlivým použitím`)
};

const bg_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Съответствие с честната употреба`)
};

const ru_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Соответствие добросовестному использованию`)
};

const uk_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Дотримання добросовісного використання`)
};

const ar_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. الامتثال للاستخدام العادل`)
};

const hi_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. अनुपालन`)
};

const th_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. การปฏิบัติตามการใช้งานโดยชอบ`)
};

const ja_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. フェアユースの遵守`)
};

const zh_cn2_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. 合理使用合规性`)
};

const zh_hant1_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. 合理使用合規性`)
};

const ko_misc_fairuse_section3title2 = /** @type {(inputs: Misc_Fairuse_Section3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. 공정 사용 준수`)
};

/**
* | output |
* | --- |
* | "3. Compliance with Fair Use" |
*
* @param {Misc_Fairuse_Section3title2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_fairuse_section3title2 = /** @type {((inputs?: Misc_Fairuse_Section3title2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Fairuse_Section3title2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_fairuse_section3title2(inputs)
	if (locale === "ms") return ms_misc_fairuse_section3title2(inputs)
	if (locale === "da") return da_misc_fairuse_section3title2(inputs)
	if (locale === "de") return de_misc_fairuse_section3title2(inputs)
	if (locale === "en-US") return en_us2_misc_fairuse_section3title2(inputs)
	if (locale === "es-ES") return es_es2_misc_fairuse_section3title2(inputs)
	if (locale === "es-MX") return es_mx2_misc_fairuse_section3title2(inputs)
	if (locale === "fil") return fil_misc_fairuse_section3title2(inputs)
	if (locale === "fr") return fr_misc_fairuse_section3title2(inputs)
	if (locale === "it") return it_misc_fairuse_section3title2(inputs)
	if (locale === "hu") return hu_misc_fairuse_section3title2(inputs)
	if (locale === "nl") return nl_misc_fairuse_section3title2(inputs)
	if (locale === "no") return no_misc_fairuse_section3title2(inputs)
	if (locale === "pl") return pl_misc_fairuse_section3title2(inputs)
	if (locale === "pt-BR") return pt_br2_misc_fairuse_section3title2(inputs)
	if (locale === "pt") return pt_misc_fairuse_section3title2(inputs)
	if (locale === "ro") return ro_misc_fairuse_section3title2(inputs)
	if (locale === "fi") return fi_misc_fairuse_section3title2(inputs)
	if (locale === "sv") return sv_misc_fairuse_section3title2(inputs)
	if (locale === "vi") return vi_misc_fairuse_section3title2(inputs)
	if (locale === "tr") return tr_misc_fairuse_section3title2(inputs)
	if (locale === "cs") return cs_misc_fairuse_section3title2(inputs)
	if (locale === "bg") return bg_misc_fairuse_section3title2(inputs)
	if (locale === "ru") return ru_misc_fairuse_section3title2(inputs)
	if (locale === "uk") return uk_misc_fairuse_section3title2(inputs)
	if (locale === "ar") return ar_misc_fairuse_section3title2(inputs)
	if (locale === "hi") return hi_misc_fairuse_section3title2(inputs)
	if (locale === "th") return th_misc_fairuse_section3title2(inputs)
	if (locale === "ja") return ja_misc_fairuse_section3title2(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_fairuse_section3title2(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_fairuse_section3title2(inputs)
	return ko_misc_fairuse_section3title2(inputs)
});
export { misc_fairuse_section3title2 as "misc.fairUse.section3Title" }